import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Bill } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { useEntitiesById } from "@hooks/useEntities";

export const EntityCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Bill, any>) => {
        const entitiesById = useEntitiesById();
        const entity = entitiesById.get(row.original.entityId);

        return (
            <ViewTableCell>
                {entity && <EntityAvatar size="xs" entity={entity} />}
            </ViewTableCell>
        );
    },
);
